import { action } from 'mobx';
import { api } from 'shared/api/api';
import { EntityStore } from 'shared/stores/EntityStore';

export class JobApplicationHistoryStore extends EntityStore {
	entityPluralEndpoint = 'job-applications/history';
	constructor() {
		super('job-application-history');
	}

	@action
	async updateHistory(jobApplicationId, historyId, history) {
		const result = await api.put(
			`job-applications/${jobApplicationId}/history/${historyId}`,
			history
		);
		return result;
	}
}

export const jobApplicationHistoryStore = new JobApplicationHistoryStore();
